require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
import 'flatpickr/dist/flatpickr.css';
import 'select2/dist/css/select2.min.css';

require("./custom/header");

(function ($) {


    if ($(".section-accordion").length > 0) {
        require("./custom/accordion.es6");
    }

    if ($(".single-apartments").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./custom/single-apartments.es6");
    }

    if ($(".section-apartments-overview").length > 0) {
        require("./custom/apartments-overview.es6");
    }

    if ($(".page-template-booking-short-term").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./custom/short-term-booking.es6");
    }

    if ($(".page-template-booking-long-term").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./custom/long-term-booking.es6");
    }

    if ($(".page-template-confirmation-page").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./custom/confirmation.es6");
    }

    if ($(".page-template-confirmation-page-long").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./custom/confirmation-long.es6");
    }

    if ($(".section-search-form").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./custom/search_form.es6");
    }

    if ($(".section-recently-viewed-apartments").length > 0) {
        require("./custom/recently-viewed-apartments.es6");
    }

    if ($(".section-our-top-picks").length > 0) {
        require("./custom/our-top-picks.es6");
    }

})(jQuery);